import React, { useState } from "react"
import { Box } from "@mui/material"
import { AppPillToggle } from "@components"
import { dsRepricingDrawerData } from "Pages/DsRepricing/Page/@signals"

export default function DsRepricingCompareBy() {
	const initial = dsRepricingDrawerData.peek().compareByCategory ?? false
	const [selected, setSelected] = useState(initial ? 'category' : 'acriss')

	const handleChange = (_, newVal) => {
		if (newVal === null) return
		setSelected(newVal)
		const tools = dsRepricingDrawerData.value.tools
		const tethering = dsRepricingDrawerData.value.tethering
		dsRepricingDrawerData.value = {
			...dsRepricingDrawerData.value,
			compareByCategory: newVal === 'category',
			filterAcriss: [],
			filterAcrissExclusion: false,
			filterCategories: [],
			filterCategoriesExclusion: false,
			// The Smart pricing ladders are built out of whichever entity this toggle selects, so
			// switching invalidates them just like it invalidates the filters above.
			...(tools ? { tools: { ...tools, smartAcrissGroups: [], smartCategoryGroups: [] } } : {}),
			// Same for the tethering links of that dimension: ACRISS codes are not categories.
			...(tethering ? { tethering: { ...tethering, acriss: [] } } : {}),
		}
	}

	// The card around this component supplies the section title.
	return (
		<Box>
			{/* The same handler as before: picking the other option also resets the filters */}
			<AppPillToggle size="small" value={selected} onChange={value => handleChange(null, value)}
			               options={[{ value: 'acriss', label: 'ACRISS' }, { value: 'category', label: 'Category' }]}/>
		</Box>
	)
}